import { OrderPaymentTypesService } from '@/backend/market'
import { OrderPaymentTypeRepository } from '../../domain/repositories/OrderPaymentTypeRepository'
import { OrderPaymentTypeModel } from '../models/OrderPaymentTypeModel'
import type { OrderPaymentTypeEntity } from '../../domain/entities/OrderPaymentTypeEntity'

export class OrderPaymentTypeRepositoryImpl implements OrderPaymentTypeRepository {
  async getOrderPaymentTypes(): Promise<OrderPaymentTypeEntity[] | { error: true }> {
    try {
      const response = await OrderPaymentTypesService.getOrderPaymentTypesAdmin()
      const orderPaymentTypeModel = response.orderPaymentTypes?.map(
        (item) => new OrderPaymentTypeModel(item)
      )

      return orderPaymentTypeModel ?? []
    } catch {
      return { error: true }
    }
  }
  async updateOrderPaymentType(
    id: number,
    changes: Partial<
      Pick<OrderPaymentTypeEntity, 'enabled' | 'feePercentage' | 'minimumFee' | 'minimumAppVersion'>
    >
  ): Promise<{ success: true } | { error: true }> {
    try {
      await OrderPaymentTypesService.putOrderPaymentTypeAdmin({
        id,
        requestBody: changes
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
